
import React from 'react'
import UiMainApp from './ui/uiMainApp';
import { AppCore } from './AppCore';

class AppController extends React.Component {
    constructor(props) {
        super(props);

        this.core = new AppCore(this.apiAuthError);
        this.mainAppRef = React.createRef();

        this.state = {
            services: {
                thingsboard: this.core.getServices().thingsboard.getServices(),
                chirpstack: this.core.getServices().chirpstack.getServices()
            },
            coreState: {
                thingsboard: {
                    loggedIn: undefined,
                },
                chirpstack: {
                    loggedIn: undefined,
                }
            }
        };

        this.uiSignals = {
            updateState: this.updateUiState,
        };

        this.core.setSignals(this.uiSignals);
    }

    updateUiState = (coreStateObj) => {
        let state = this.state;
        state.coreState = Object.assign(state.coreState, coreStateObj);

        this.setState(state);
    }



    loggedIn = (loginSts) => {
        let sts = this.state;
        sts.coreState.thingsboard.loggedIn = loginSts;
        this.updateUiState(sts);
    };


    render() {
        return <UiMainApp ref={this.mainAppRef}
            services={this.state.services}
            coreState={this.state.coreState} />;
    }

    apiAuthError = (resp) => {
        let loggedOut = false;
        if ((resp.status === 401) && resp.message.includes("oken")) {
           this.mainAppRef.current.logout();
           loggedOut = true;
        }
        else if(resp.message === "NetworkError when attempting to fetch resource."){
            this.mainAppRef.current.logout();
            loggedOut = true;
        }
        else{
            throw resp;
        }
        
        return loggedOut;
    }
}


export default AppController;
